import { render } from "./AgListaGastos.vue?vue&type=template&id=6bf3870c&scoped=true"
import script from "./AgListaGastos.vue?vue&type=script&lang=js"
export * from "./AgListaGastos.vue?vue&type=script&lang=js"

import "./AgListaGastos.vue?vue&type=style&index=0&id=6bf3870c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf3870c"]])

export default __exports__